<template>
  <v-card
    class="overflow-hidden position-relative item"
    color="white"
    :to="to"
    flat
  >
    <img
      @error="onError"
      class="d-block item-img"
      :src="files + img + '?resize=1&w=700'"
      :alt="title"
    />

    <div class="d-flex flex-column justify-end item-content">
      <div class="px-4 px-md-7 item-content-bg">
        <div
          class="white--text text-body-1 font-weight-bold item-title"
          :class="[small ? ' text-md-subtitle-1' : 'text-sm-h5 text-md-h4']"
        >
          {{ title }}
        </div>

        <div
          class="white--text text-caption font-weight-regular"
          :class="[small ? 'mt-2' : 'text-sm-body-1 mt-3']"
        >
          {{
            formatDate(date, { day: "numeric", month: "long", year: "numeric" })
          }}
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import DefaultImg from "../../assets/img/default-img.png";
import { formatDate } from "../../utils/formatDate";

export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onError(e) {
      e.target.src = DefaultImg;
    },
    formatDate,
  },
};
</script>

<style lang="scss" scoped>
.item {
  border-radius: 10px !important;

  &-img {
    aspect-ratio: 695 / 495;
    object-fit: cover;
    width: 100%;
  }

  &-content {
    bottom: 0;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: all 0.1s linear;

    &-bg {
      background: rgb(0, 0, 0);
      background: -moz-linear-gradient(
        0deg,
        rgba(0, 0, 0, 1) 0,
        rgba(0, 0, 0, 0) 100%
      );
      background: -webkit-linear-gradient(
        0deg,
        rgba(0, 0, 0, 1) 0,
        rgba(0, 0, 0, 0) 100%
      );
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 1) 0,
        rgba(0, 0, 0, 0) 100%
      );
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#000000",GradientType=1);
      padding-bottom: 26px;
      padding-top: 50px;
      pointer-events: initial;
    }
  }
}
</style>
